<div class="sidebar-head">
    <span class="svg svg-toggle-icon" (click)="toggleSideBar()"></span>
</div>
<div class="head">
    <h2>{{ title }} <span class="text-sm text-color-secondary font-normal">{{tagline}}</span></h2>
    <div class="action">
        <button 
            *ngIf="isCompanyAdmin || isEmployee"
            style="width: auto" 
            pButton 
            pRipple 
            [icon]="'pi pi-linkedin'" 
            tooltipPosition="top" 
            [pTooltip]="linkedInButton == 'true' ? 'LinkedIn Profile connected':'Connect LinkedIn Profile'" 
            severity="secondary" 
            (click)="lnmenu.toggle($event)"
            class="p-button-rounded lkn-btn mr-2 btn-small-round p-button-text"
            [ngClass]="{'active': linkedInButton == 'true'}">
        </button>    
        <p-menu class="fb-dropdown" #lnmenu [model]="linkedInDropItems" [popup]="true" />
        <button 
            *ngIf="isCompanyAdmin || isEmployee"
            style="width: auto" 
            pButton 
            pRipple 
            [icon]="'pi pi-facebook'" 
            tooltipPosition="top" 
            [pTooltip]="facebookButton == 'true' ? 'Facebook Profile connected':'Connect Facebook Profile'" 
            severity="secondary" 
            (click)="fbmenu.toggle($event)"
            class="p-button-rounded fb-btn btn-small-round p-button-text"
            [ngClass]="{'active': facebookButton == 'true'}">
        </button>
        <p-menu class="fb-dropdown" #fbmenu [model]="facebookItems" [popup]="true" />

        <button 
            *ngIf="isCompanyAdmin || isEmployee"
            style="width: auto" 
            pButton 
            pRipple 
            [icon]="'pi pi-instagram'" 
            tooltipPosition="top" 
            [pTooltip]="instaButton == 'true' ? 'Instagram Profile connected':'Connect Instagram Profile'" 
            severity="secondary" 
            (click)="Instamenu.toggle($event)"
            class="p-button-rounded ml-2 btn-small-round p-button-text insta-btn"
            [ngClass]="{'active': instaButton == 'true'}">
        </button>    
        <p-menu class="fb-dropdown" #Instamenu [model]="instaDropItems" [popup]="true" />

        <button 
            *ngIf="isCompanyAdmin || isEmployee"
            style="width: auto" 
            pButton 
            pRipple 
            [icon]="'pi pi-twitter'" 
            tooltipPosition="left" 
            [pTooltip]="twitterButton == 'true' ? 'Twitter Profile connected':'Connect Twitter Profile'" 
            severity="secondary" 
            (click)="Twitteramenu.toggle($event)"
            class="p-button-rounded twitter-btn ml-2 btn-small-round p-button-text"
            [ngClass]="{'active': twitterButton == 'true'}">
        </button>    
        <p-menu class="fb-dropdown" #Twitteramenu [model]="twitterDropItems" [popup]="true" />
        
    </div>
</div>